module.exports = __webpack_public_path__ + "img/leader_ko_m.1ef0af83.svg";